import React, { useState } from "react";
import styled from "styled-components";
import Theme from "../Theme/Theme";
import StudentRightSide from "../Components/StudentRightSide/StudentRightSide";
import StudentLeftSide from "../Components/StudentLeftSide/StudentLeftSide";

function MainStudentScreen() {
  const [navItems] = useState([
    {
      id: 1,
      img: "/Assets/Images/NavigatorIcons/MakeRequestIcon/Grey.svg",
      activeImg: "/Assets/Images/NavigatorIcons/MakeRequestIcon/Blue.svg",
      navigate: "/dashboard/create-request",
      text: "ایجاد درخواست",
    },
    {
      id: 2,
      img: "/Assets/Images/NavigatorIcons/CheckRequestStudentIcon/Grey.svg",
      activeImg:
        "/Assets/Images/NavigatorIcons/CheckRequestStudentIcon/Blue.svg",
      navigate: "/dashboard/all-request",
      text: "پیگیری درخواست",
    },
    {
      id: 3,
      img: "/Assets/Images/NavigatorIcons/SettingIcon/Grey.svg",
      activeImg: "/Assets/Images/NavigatorIcons/SettingIcon/Blue.svg",
      navigate: "/dashboard/setting",
      text: "تنظیمات",
    },
  ]);

  return (
    <Container>
      <StudentRightSide data={navItems}></StudentRightSide>
      <StudentLeftSide></StudentLeftSide>
    </Container>
  );
}

export default MainStudentScreen;

const Container = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 97vh;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  background-color: ${Theme.colorBackgroundPage};
`;
